// Real Firebase initialization — Firestore + Auth (Storage disabled, images by URL).
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCoCCVWxva1iJcZWGYMXdTca7C8U86yr5g",
  authDomain: "phobia-ab7c3.firebaseapp.com",
  projectId: "phobia-ab7c3",
  storageBucket: "phobia-ab7c3.firebasestorage.app",
  messagingSenderId: "636535721408",
  appId: "1:636535721408:web:6cd4f8a1a7bfa74c77cc25",
  measurementId: "G-V5RW3E21YS",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

// Storage intentionally disabled — admin adds images as URLs.
export const storage = null;

export default db;
